import { tv } from "../../variants/tv.js";
const ulVariants = tv({
    base: 'list-disc ps-7',
    variants: {}
});
export { ulVariants };
